// index.js
import { extendTheme } from "@chakra-ui/react";
import components from "./components";
import { typography } from "./foundations/typography";
import { colors } from "./foundations/colors";

let EsgTheme = extendTheme({
	...typography,
	colors,
	components,
	styles: {
		global: {
			"html, body": {
				fontFamily: "Plus Jakarta Sans, sans-serif"
			}
		}
	}
});


export default EsgTheme;